import React, { Component } from 'react'
import PoseCard from './PoseCard'
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { shuffle } from '../../helpers/arrayHelpers'

class PoseList extends Component {
  render() {
    let poses = this.props.poses || [];
    const originalPosesLength = poses.length;
    let filter = this.props.poseFilter;

    if(filter) {
      if(filter.levels) {
        poses = poses.filter(pose => {
          return filter.levels.includes(pose.level)
        })
      }

      if(filter.types) {
        poses = poses.filter(pose => {
          return !pose.types.some(type => filter.types.includes(type))
        })
      }
    }

    // should this come from a filter? another config setting?
    const numberOfPoses = 6;
    if(poses.length > numberOfPoses) {
      shuffle(poses)
      poses = poses.slice(0, numberOfPoses);
    }
    
    const poseList  = poses.length ? (poses.map(pose => {
      return (
          <PoseCard key={pose.id} pose={pose} />
      )
    })
    ) : originalPosesLength !== 0 ? (
      <div className="container center error">
        <h5>It looks like we don't have any pose to display...</h5>
        <h5>...why don't you try lying down!</h5>
        <img className="errorPhoto" src="yoga-no-pose.jpg" alt="yoga pose savasana"/>
      </div>
    ) : (
      <div className="container">Loading...</div>
    )

    return (
      <div>
        <div className="row">
        { poseList }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    poses: state.firestore.ordered.poses,
    poseFilter: state.site.poseFilter
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    { collection: 'poses' }
  ])
)(PoseList)